import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { PickupStatsCategories } from '../../../../helpers';
import { IMatchFinalBoxScoreDto } from '../../../../WorldDoomLeague';
import MatchOverallPickupsTable from './MatchOverallPickupsTable';

interface MatchOverallPickupsTabsViewProps {
    category: PickupStatsCategories;
    finalBoxScore: IMatchFinalBoxScoreDto;
    categoriesObject: PickupStatsCategories[];
};

const MatchOverallPickupsTabsView = (props: MatchOverallPickupsTabsViewProps) => {

    return (
        <React.Fragment>
            <TabContent activeTab={props.category}>
                {props.categoriesObject && props.categoriesObject.map((s, idx) => (
                    <TabPane tabId={s} key={idx}>
                        <MatchOverallPickupsTable activeCategory={props.category} finalBoxScore={props.finalBoxScore} />
                    </TabPane>
                    ))}
            </TabContent>
        </React.Fragment>);
};

export default MatchOverallPickupsTabsView;